import { render, staticRenderFns } from "./MonthStatementCheck.vue?vue&type=template&id=2ccc4406&"
import script from "./MonthStatementCheck.vue?vue&type=script&lang=js&"
export * from "./MonthStatementCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports